const ComaIcon = ({ className }: { className?: string }) => {
  return (
    <div className={className}>
      <svg
        width={"1em"}
        height={"1em"}
        viewBox="0 0 55 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 44V32.0559C0 28.3673 0.644302 24.5615 1.93291 20.6387C3.28009 16.6574 5.12513 12.8809 7.46805 9.30938C9.86954 5.67931 12.5932 2.57618 15.639 0L26.1821 6.58683C23.8392 10.2754 21.9063 14.169 20.3834 18.2675C18.9191 22.3074 18.1869 26.8743 18.1869 31.9681V44H0ZM28.8179 44V32.0559C28.8179 28.3673 29.4622 24.5615 30.7508 20.6387C32.098 16.6574 33.943 12.8809 36.2859 9.30938C38.6874 5.67931 41.4111 2.57618 44.4569 0L55 6.58683C52.6571 10.2754 50.7242 14.169 49.2013 18.2675C47.737 22.3074 47.0048 26.8743 47.0048 31.9681V44H28.8179Z"
          fill="#D7DFE9"
        />
      </svg>
    </div>
  );
};

export default ComaIcon;
